<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <!-- Search container -->
        <!-- <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('search.title')"
                  v-model="search.searchText"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success"
                  @click="onSearchCase"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div> -->
        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartmentType.title") }}</b>
              <lte-button
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-plus"
                v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_apartment')"
                @click="addNew($event)"
                >{{ $t("common.addnew") }}</lte-button
              >
            </div>
          </div>
          <div class="box-body">
            <!-- B-Table Start -->
            <b-table
              :items="gridDataList"
              :fields="gridColumns"
              class="mt-3"
              outlined
              responsive
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-danger dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 50px">
                    <li>
                      <button
                        v-if="
                          GET_ACCOUNT_DATA.id == 1 ||
                            has_perm('update_apartment')
                        "
                        class="btn btn-primary btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenEditInput(row.item)"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                    </li>
                    <li style="margin-top: 5px">
                      <button
                        v-if="
                          GET_ACCOUNT_DATA.id == 1 ||
                            has_perm('delete_apartment')
                        "
                        class="btn btn-danger btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenDelete(row.item)"
                      >
                        <i class="glyphicon glyphicon-trash"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </template>
            </b-table>
            <!-- B-Table End -->
          </div>
        </div>
        <!--  -->
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
    <!-- /.modal -->
    <div
      class="modal fade"
      :ref="`modal-apartment-type`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  apartmentTypeData.id === 0
                    ? "apartmentType.apartmentTypeAdd"
                    : "apartmentType.apartmentTypeDetail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label required" for="">{{
                        $t("apartmentType.apartmentTypeName")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="apartmentTypeData.apartmentTypeName"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label required" for="">{{
                        $t("apartmentType.apartmentTypeCode")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="apartmentTypeData.apartmentTypeCode"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label required" for="">{{
                        $t("apartment.size")
                      }}</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="apartmentTypeData.size"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label required" for="">{{
                        $t("apartmentType.adults")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="apartmentTypeData.adults"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label required" for="">{{
                        $t("apartmentType.children")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="apartmentTypeData.children"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{ $t("apartmentType.bedrooms") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="apartmentTypeData.bedrooms"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="">{{
                            $t("apartmentType.bathroom")
                          }}</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="apartmentTypeData.bathroom"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="">{{
                            $t("apartmentType.description")
                          }}</label>
                          <textarea
                            class="form-control"
                            name=""
                            id=""
                            cols="30"
                            rows="4"
                            v-model="apartmentTypeData.description"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">{{ $t("banner.image") }}</label>
                      <div style="overflow: auto; max-height: 270px;">
                        <div
                          class="apartment-img-block"
                          v-for="(item, index) in apartmentTypeImgList"
                          :key="item + index"
                        >
                          <img
                            id="apartment-img-id"
                            class="apartment-type-class img-responsive"
                            :src="item.imgUrl"
                            alt="apartment-img"
                          />
                        </div>
                        <div class="apartment-img-block">
                          <img
                            id="apartment-img-id"
                            class="apartment-type-class img-responsive"
                            :src="noImgDefault"
                            @click="
                              onClickAddImg(apartmentTypeImgList.length + 1)
                            "
                            alt="apartment-img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <apartment-type-img
      ref="apartmentTypeImg"
      @apartmentTypeImgEmit="apartmentTypeImgUpload"
    />
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
// import moment from "moment";
import Loading from "vue-loading-overlay";
import configuration from "@/lib/config";
import ApartmentTypeImg from "./ApartmentTypeImg";

export default {
  name: "CaseList",
  data() {
    return {
      gridDataList: [],
      gridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          class: "text-center "
        },
        {
          label: "apartmentType.apartmentTypeName",
          key: "apartmentTypeName",
          class: "text-center "
        },
        {
          label: "apartmentType.apartmentTypeCode",
          key: "apartmentTypeCode",
          class: "text-center "
        },
        {
          label: "apartmentType.adults",
          key: "adults",
          class: "text-center "
        },
        {
          label: "apartmentType.children",
          key: "children",
          class: "text-center "
        },
        {
          label: "apartmentType.description",
          key: "description",
          class: "text-center "
        },
        { key: "actions", label: "common.action" }
      ],
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      search: {
        searchText: ""
      },
      isLoading: false,
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      apartmentTypeData: {
        id: 0,
        apartmentTypeName: null,
        apartmentTypeCode: null,
        description: null,
        adults: 0,
        children: 0,
        bedrooms: 0,
        bathroom: 0,
        size: null
      },
      noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
      apartmentTypeImgList: []
    };
  },
  watch: {
    GET_LANG: function() {
      this.getApartmentTypeList(1);
    },
    GET_APARTMENT_TYPE_LIST_DATA: function() {
      let paginate = this.GET_APARTMENT_TYPE_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridDataList = [];
      let data = this.GET_APARTMENT_TYPE_LIST_DATA.results;

      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;

        let data = {
          id: id,
          nonumber: nonumber,
          apartmentTypeName: element.name,
          apartmentTypeCode: element.code,
          description: element.description,
          adults: element.adults,
          children: element.children,
          bedrooms: element.bedrooms,
          bathroom: element.bathroom,
          size: element.size,
          imgList: element.img_list
        };
        this.gridDataList.push(data);
      });
      this.gridDataList.reverse();
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_TYPE_LIST_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getSearchData: function(data) {
      this.search.searchText = data;
      this.getApartmentTypeList(1);
    },
    onSearchCase: function() {
      this.getApartmentTypeList(1);
    },
    addNew: function() {
      $(this.$refs[`modal-apartment-type`]).modal("show");
      this.apartmentTypeData = {
        id: 0,
        apartmentTypeName: null,
        apartmentTypeCode: null,
        description: null,
        adults: 0,
        children: 0,
        bedrooms: 0,
        bathroom: 0,
        size: null
      };
      this.apartmentTypeImgList = [];
    },
    onOpenEditInput: function(row) {
      $(this.$refs[`modal-apartment-type`]).modal("show");
      this.apartmentTypeData = {
        id: row.id,
        apartmentTypeName: row.apartmentTypeName,
        apartmentTypeCode: row.apartmentTypeCode,
        description: row.description,
        adults: row.adults,
        children: row.children,
        bedrooms: row.bedrooms,
        bathroom: row.bathroom,
        size: row.size
      };
      this.apartmentTypeImgList = [];
      row.imgList.forEach((data, index) => {
        let item = {
          id: data.id,
          imgUrl: data.img_url,
          description: data.description,
          index: index
        };
        this.apartmentTypeImgList.push(item);
      });
    },

    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_APARTMENT_TYPE(this.originalRecordData)
        .then(
          function() {
            this.getApartmentTypeList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getApartmentTypeList(data)
    },
    closeModal() {
      this.isModalVisible = false;
    },

    onOpenDelete: function(row) {
      this.originalRecordData = row;
      this.isModalVisible = true;
    },
    getApartmentTypeList: function(page) {
      this.isLoading = true;
      let filter = {
        params: {
          page: page,
          searchText: this.search.searchText
        }
      };
      this.GET_APARTMENT_TYPE_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onGetData: function() {
      this.getApartmentTypeList(this.paginateData.currentPage);
    },
    validateData: function() {
      let validatedResult = "OK";
      for (let key in this.apartmentTypeData) {
        if (key === "description" || key === "bedrooms" || key === "bathroom") {
          //
        } else if (utils.isEmptyString(this.apartmentTypeData[key])) {
          validatedResult = this.$t("apartmentType." + key);
          break;
        }
      }
      return validatedResult;
    },
    onSave: function() {
      let results = this.validateData();
      if (results === "OK") {
        let data = {
          id: this.apartmentTypeData.id,
          name: this.apartmentTypeData.apartmentTypeName,
          code: this.apartmentTypeData.apartmentTypeCode,
          description: this.apartmentTypeData.description,
          adults: this.apartmentTypeData.adults,
          children: this.apartmentTypeData.children,
          bedrooms: this.apartmentTypeData.bedrooms,
          bathroom: this.apartmentTypeData.bathroom,
          size: this.apartmentTypeData.size,
          imgList: this.apartmentTypeImgList
        };
        if (this.apartmentTypeData.id === 0) {
          this.CREATE_APARTMENT_TYPE(data)
            .then(
              function() {
                $(this.$refs[`modal-apartment-type`]).modal("hide");
                this.getApartmentTypeList(this.paginateData.currentPage);
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_APARTMENT_TYPE(data)
            .then(
              function() {
                $(this.$refs[`modal-apartment-type`]).modal("hide");
                this.getApartmentTypeList(this.paginateData.currentPage);
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST();
              }.bind(this)
            );
        }
      } else {
        this.ON_SHOW_TOAST({
          message: results,
          styleType: "danger"
        });
      }
    },
    onClickAddImg: function(index) {
      this.$refs.apartmentTypeImg.onShowAddNew(index);
    },
    apartmentTypeImgUpload: function(data) {
      let item = {
        id: data.id,
        imgUrl: data.imgUrl,
        description: data.description,
        index: data.index
      };
      if (data.index > this.apartmentTypeImgList.length) {
        this.apartmentTypeImgList.push(item);
      } else {
        let imgData = this.apartmentTypeImgList[data.index];
        imgData.imgUrl = data.imgUrl;
        imgData.description = data.description;
      }
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "DELETE_APARTMENT_TYPE",
      "GET_APARTMENT_TYPE_LIST",
      "CREATE_APARTMENT_TYPE",
      "UPDATE_APARTMENT_TYPE",
    ])
  },
  mounted() {
    this.getApartmentTypeList(1);
  },

  components: {
    "lte-button": LTEButton,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    ApartmentTypeImg
  }
};
</script>
<style scoped>
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}

.apartment-type-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
  padding: 5px;
}

.apartment-img-block {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentType/ApartmentTypeList.vue